module.exports = __webpack_public_path__ + "img/go-back.04b37ad2.svg";